import { useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/compte`;
const listeners = new Set();
let cache;

export const authHeaders = () => ({});
const notify = (u) => { cache = u; listeners.forEach((l) => l(u)); };

export const formatErr = (d) => (d == null ? "Une erreur est survenue — réessayez." : typeof d === "string" ? d : Array.isArray(d) ? d.map((e) => e?.msg || JSON.stringify(e)).join(" ") : d.msg || String(d));

export const compte = {
  inscription: (p) => axios.post(`${API}/inscription`, p, { withCredentials: true }).then((r) => { notify(r.data); return r.data; }),
  connexion: (p) => axios.post(`${API}/connexion`, p, { withCredentials: true }).then((r) => { notify(r.data); return r.data; }),
  googleSession: (session_id) => axios.post(`${API}/google/session`, { session_id }, { withCredentials: true }).then((r) => { notify(r.data); return r.data; }),
  deconnexion: async () => { await axios.post(`${API}/deconnexion`, {}, { withCredentials: true }).catch(() => {}); notify(false); },
  oublie: (email) => axios.post(`${API}/mot-de-passe-oublie`, { email, origin_url: window.location.origin }).then((r) => r.data),
  reinitialiser: (token, password) => axios.post(`${API}/reinitialiser`, { token, password }).then((r) => r.data),
  wyrdInvitationVerifier: (token) => axios.post(`${API}/wyrd-invitation/verifier`, { token }).then((r) => r.data),
  wyrdInvitationActiver: (token, password) => axios.post(`${API}/wyrd-invitation/activer`, { token, password }, { withCredentials: true }).then((r) => { notify(r.data.utilisateur); return r.data; }),
  formations: () => axios.get(`${API}/formations/moi`, { withCredentials: true }).then((r) => r.data),
  formation: (courseId) => axios.get(`${API}/formations/${courseId}/apprendre`, { withCredentials: true }).then((r) => r.data),
  formationProgression: (lessonId, data) => axios.post(`${API}/formations/lecons/${lessonId}/progression`, data, { withCredentials: true }).then((r) => r.data),
  formationMediaUrl: (mediaId) => axios.get(`${API}/formations/medias/${mediaId}/url`, { withCredentials: true }).then((r) => r.data),
  administration: () => axios.post(`${API}/administration`, {}, { withCredentials: true }).then((r) => r.data),
  clientProfil: () => axios.get(`${API}/client-profil`, { withCredentials: true }).then((r) => r.data),
  updateClientProfil: (data) => axios.put(`${API}/client-profil`, data, { withCredentials: true }).then((r) => r.data),
  espace: () => axios.get(`${API}/espace`, { headers: authHeaders(), withCredentials: true }).then((r) => r.data),
  wyrdInscrire: (event_id, telephone) => axios.post(`${API}/wyrd/inscrire`, { event_id, telephone }, { headers: authHeaders(), withCredentials: true }).then((r) => r.data),
};

export const useUser = () => {
  const [user, setUser] = useState(cache);
  useEffect(() => {
    listeners.add(setUser);
    if (cache === undefined) {
      axios.get(`${API}/moi`, { headers: authHeaders(), withCredentials: true }).then((r) => notify(r.data)).catch(() => notify(false));
    }
    return () => listeners.delete(setUser);
  }, []);
  const refresh = useCallback(() => axios.get(`${API}/moi`, { headers: authHeaders(), withCredentials: true }).then((r) => notify(r.data)).catch(() => notify(false)), []);
  return { user, loading: user === undefined, refresh };
};
